export const buildInfo = {
  "buildNumber": 24
};